"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = exports.REGISTER_ENDPOINT = exports.LOGIN_ENDPOINT = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _axios = _interopRequireDefault(require("axios"));

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var _buttonControl = _interopRequireDefault(require("../button-control"));

var _Forbidden = _interopRequireDefault(require("@insided/destination/icons/Forbidden"));

var _constants = require("@insided/shared/constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var REQUIRED_FIELDS = ['username', 'login', 'password'];
var FORGOT_PASSWORD_URL = "".concat((0, _globals.default)('communityUrl'), "/member/forgotPassword");
var cssAnchorName = 'login-control';
exports.cssAnchorName = cssAnchorName;
var LOGIN_ENDPOINT = '/member/login';
exports.LOGIN_ENDPOINT = LOGIN_ENDPOINT;
var REGISTER_ENDPOINT = '/member/register';
exports.REGISTER_ENDPOINT = REGISTER_ENDPOINT;
var STAFF_LOGIN_COMMUNITY_URL = "https://sso.api.insided.com/auth/insidedgodmode?customer=godmode&return_url=".concat((0, _globals.default)('communityUrl'), "/ssoproxy/return");
var STAFF_LOGIN_CONTROL_URL = "https://sso.api.insided.com/auth/insidedgodmode?customer=godmode&return_url=".concat((0, _globals.default)('controlUrl'), "/ssoproxy/return");
var DEFAULT_BACKEND_ERROR_MESSAGE = (0, _preact.h)("div", null, "Something went wrong, please try again later");
var INVALID_CREDENTIALS_BACKEND_ERROR_MESSAGE = (0, _preact.h)("div", null, "The email address/username or password you entered is incorrect. If you need to, you can", ' ', (0, _preact.h)("a", {
  href: (0, _absoluteUrlRuntime.resolveUrl)(FORGOT_PASSWORD_URL),
  target: "__blank"
}, "reset your password"), ".");
var ERROR_MESSAGES = {
  username: 'Please enter your username',
  login: 'Please enter your email / username',
  password: 'Please enter your password',
  firstname: 'Please enter your first name',
  lastname: 'Please enter your last name'
};

var getDefaultCredentials = function getDefaultCredentials() {
  return {
    email: '',
    username: '',
    login: '',
    password: '',
    remember: false
  };
};

var onLoginSucceeded = function onLoginSucceeded(response) {
  var redirect = response.data.redirect;
  window.location.replace(redirect);
  window.sessionStorage.setItem('UserLoggedInControl', String(true));
};

var onRegisterSucceeded = function onRegisterSucceeded(response) {
  var redirect = response.data.redirect;
  window.location.replace(redirect);
};

var InvalidCredentialsAlert = function InvalidCredentialsAlert(_ref) {
  var error = _ref.error;
  return (0, _preact.h)("div", {
    className: "invalid-credentials-alert"
  }, (0, _preact.h)(_Forbidden.default, {
    fill: "#E94C5C"
  }), error);
};

var LoginControl = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(LoginControl, _Component);

  var _super = _createSuper(LoginControl);

  function LoginControl() {
    var _this;

    (0, _classCallCheck2.default)(this, LoginControl);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      credentials: getDefaultCredentials(),
      formErrors: {},
      backendError: null,
      isLoading: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onLoginFailed", function (errorResponse) {
      var status = errorResponse.status;

      if (status === 422) {
        _this.setState({
          credentials: getDefaultCredentials(),
          backendError: INVALID_CREDENTIALS_BACKEND_ERROR_MESSAGE
        });

        return;
      }

      _this.setState({
        credentials: getDefaultCredentials(),
        backendError: DEFAULT_BACKEND_ERROR_MESSAGE
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onRegisterFailed", function (errorResponse) {
      var data = errorResponse.data,
          status = errorResponse.status;

      if (status === 422) {
        data.forEach(function (error) {
          var name = error.name,
              description = error.description;

          _this.setState(function (prevState) {
            return {
              credentials: Object.assign(prevState.credentials, {
                password: ''
              }),
              formErrors: _objectSpread(_objectSpread({}, prevState.formErrors), (0, _defineProperty2.default)({}, name, description)),
              backendError: null
            };
          });
        });
        return;
      }

      _this.setState(function (prevState) {
        return {
          credentials: Object.assign(prevState.credentials, {
            password: ''
          }),
          backendError: DEFAULT_BACKEND_ERROR_MESSAGE
        };
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "RegisterRequest", {
      endpoint: REGISTER_ENDPOINT,
      fields: ['email', 'username', 'password'],
      onRequestSucceeded: onRegisterSucceeded,
      onRequestFailed: _this.onRegisterFailed
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "LoginRequest", {
      endpoint: LOGIN_ENDPOINT,
      fields: ['login', 'password'],
      onRequestSucceeded: onLoginSucceeded,
      onRequestFailed: _this.onLoginFailed
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onInputChange", function (e) {
      var target = e.target;

      if (!target) {
        return;
      } // @ts-expect-error


      var value = target.type === 'checkbox' ? target.checked : target.value; // @ts-expect-error

      var name = target.name;
      var _this$state = _this.state,
          credentials = _this$state.credentials,
          formErrors = _this$state.formErrors;

      if (REQUIRED_FIELDS.includes(name)) {
        if (typeof value !== 'boolean') {
          var inputIsEmpty = !value.trim();

          if (inputIsEmpty) {
            _this.setState({
              credentials: _objectSpread(_objectSpread({}, credentials), (0, _defineProperty2.default)({}, name, value)),
              formErrors: _objectSpread(_objectSpread({}, formErrors), (0, _defineProperty2.default)({}, name, ERROR_MESSAGES[name]))
            });

            return;
          }
        }
      }

      if (name in formErrors) {
        delete formErrors[name];
      }

      _this.setState({
        credentials: _objectSpread(_objectSpread({}, credentials), (0, _defineProperty2.default)({}, name, value)),
        formErrors: formErrors
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "validateForm", function (fields) {
      var errors = {};
      var credentials = _this.state.credentials;
      var newMemberRegistration = _this.props.newMemberRegistration;
      Object.keys(fields).forEach(function (item) {
        if (!(newMemberRegistration !== null && newMemberRegistration !== void 0 && newMemberRegistration.gainsightSSOEnabled) || newMemberRegistration !== null && newMemberRegistration !== void 0 && newMemberRegistration.gainsightSSOEnabled && item !== 'password') {
          var formField = credentials[item];
          var value = formField.trim();
          if (!value) Object.assign(errors, (0, _defineProperty2.default)({}, item, ERROR_MESSAGES[item]));
        }
      });

      if (Object.keys(errors).length > 0) {
        _this.setState({
          formErrors: errors
        });

        return false;
      }

      return true;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getValidationFields", function (fields) {
      var validationFields = {};
      var credentials = _this.state.credentials;
      fields.forEach(function (field) {
        Object.assign(validationFields, (0, _defineProperty2.default)({}, field, credentials[field]));
      });
      return validationFields;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSubmit", /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(e, request) {
        var validationFields, credentials, redirectTo, response, _response;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                e.preventDefault();
                validationFields = _this.getValidationFields(request.fields);

                if (!_this.validateForm(validationFields)) {
                  _context.next = 19;
                  break;
                }

                credentials = _this.state.credentials;
                redirectTo = _this.props.redirectTo;
                _context.prev = 5;

                _this.setState({
                  isLoading: true
                });

                credentials['redirectTo'] = redirectTo;
                _context.next = 10;
                return _axios.default.post(request.endpoint, credentials);

              case 10:
                response = _context.sent;
                request.onRequestSucceeded(response);
                _context.next = 19;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](5);
                _response = _context.t0.response;
                request.onRequestFailed(_response);

                _this.setState({
                  isLoading: false
                });

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[5, 14]]);
      }));

      return function (_x, _x2) {
        return _ref2.apply(this, arguments);
      };
    }());
    return _this;
  }

  (0, _createClass2.default)(LoginControl, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.newMemberRegistration) return;
      var newMemberRegistration = this.props.newMemberRegistration;
      var inviteeEmail = newMemberRegistration.inviteeEmail,
          inviteeRole = newMemberRegistration.inviteeRole,
          showFirstNameLastName = newMemberRegistration.showFirstNameLastName;
      this.setState(function (prevState) {
        return {
          credentials: Object.assign(prevState.credentials, {
            email: inviteeEmail,
            roleId: inviteeRole,
            firstname: '',
            lastname: ''
          })
        };
      });

      if (showFirstNameLastName) {
        this.RegisterRequest.fields = [].concat((0, _toConsumableArray2.default)(this.RegisterRequest.fields), ['firstname', 'lastname']);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          isStaffLoginEnabled = _this$props.isStaffLoginEnabled,
          customerName = _this$props.customerName,
          newMemberRegistration = _this$props.newMemberRegistration,
          invalidRegistration = _this$props.invalidRegistration;
      var _this$state2 = this.state,
          _this$state2$credenti = _this$state2.credentials,
          email = _this$state2$credenti.email,
          username = _this$state2$credenti.username,
          login = _this$state2$credenti.login,
          password = _this$state2$credenti.password,
          remember = _this$state2$credenti.remember,
          formErrors = _this$state2.formErrors,
          backendError = _this$state2.backendError,
          isLoading = _this$state2.isLoading;

      if (invalidRegistration) {
        return (0, _preact.h)(Wrapper, null, (0, _preact.h)("h2", {
          className: "control-login-title"
        }, "Invite is no longer active"), (0, _preact.h)("h3", {
          className: "control-login-subtitle"
        }, "This invite has expired, or the sender has cancelled it. Please check with the person who invited you to get a new invite."), (0, _preact.h)("a", {
          href: "https://insided.com",
          target: "_blank",
          rel: "noreferrer"
        }, (0, _preact.h)(_buttonControl.default, {
          className: "register-button",
          variant: "brand",
          title: "Learn more about inSided",
          fullWidth: true
        })));
      }

      if (newMemberRegistration) {
        var _this$state$credentia, _this$state$credentia2;

        var inviterUsername = newMemberRegistration.inviterUsername,
            gainsightSSOEnabled = newMemberRegistration.gainsightSSOEnabled,
            showFirstNameLastName = newMemberRegistration.showFirstNameLastName;
        return (0, _preact.h)(Wrapper, {
          onSubmit: function onSubmit(e) {
            return _this2.onSubmit(e, _this2.RegisterRequest);
          }
        }, (0, _preact.h)("h2", {
          className: "control-login-title"
        }, inviterUsername, " has invited you to team: ", customerName), (0, _preact.h)("h3", {
          className: "control-login-subtitle"
        }, "You are almost there. Last step: ".concat(gainsightSSOEnabled ? 'Create your username.' : 'Create an account.')), backendError && (0, _preact.h)(InvalidCredentialsAlert, {
          error: backendError
        }), (0, _preact.h)("div", {
          className: "control-login-box"
        }, (0, _preact.h)("div", {
          className: "login-input-group"
        }, (0, _preact.h)(_InputGroup.default, {
          name: "email",
          title: "Email",
          type: "email",
          value: email,
          error: formErrors['email'],
          disabled: true
        }), showFirstNameLastName && (0, _preact.h)("div", null, (0, _preact.h)(_InputGroup.default, {
          name: "firstname",
          title: "First name",
          type: "text",
          value: (_this$state$credentia = this.state.credentials['firstname']) !== null && _this$state$credentia !== void 0 ? _this$state$credentia : '',
          onChangeCallback: this.onInputChange,
          error: formErrors['firstname'],
          disabled: isLoading
        }), (0, _preact.h)(_InputGroup.default, {
          name: "lastname",
          title: "Last name",
          type: "text",
          value: (_this$state$credentia2 = this.state.credentials['lastname']) !== null && _this$state$credentia2 !== void 0 ? _this$state$credentia2 : '',
          onChangeCallback: this.onInputChange,
          error: formErrors['lastname'],
          disabled: isLoading
        })), (0, _preact.h)(_InputGroup.default, {
          name: "username",
          title: "Username",
          type: "text",
          value: username,
          onChangeCallback: this.onInputChange,
          error: formErrors['username'],
          disabled: isLoading
        }), !gainsightSSOEnabled && (0, _preact.h)(_InputGroup.default, {
          name: "password",
          title: "Password",
          type: "password",
          value: password,
          onChangeCallback: this.onInputChange,
          error: formErrors['password'],
          disabled: isLoading
        })), (0, _preact.h)(_buttonControl.default, {
          isLoading: isLoading,
          type: "submit",
          className: "register-button",
          variant: "brand",
          title: "Create account",
          fullWidth: true
        })));
      }

      return (0, _preact.h)(Wrapper, {
        onSubmit: function onSubmit(e) {
          return _this2.onSubmit(e, _this2.LoginRequest);
        }
      }, (0, _preact.h)("h2", {
        className: "control-login-title"
      }, "Log in to ", customerName), backendError && (0, _preact.h)(InvalidCredentialsAlert, {
        error: backendError
      }), (0, _preact.h)("div", {
        className: "control-login-box"
      }, (0, _preact.h)("div", {
        className: "login-input-group"
      }, (0, _preact.h)(_InputGroup.default, {
        name: "login",
        title: "Email / Username",
        type: "text",
        value: login,
        onChangeCallback: this.onInputChange,
        error: formErrors['login'],
        disabled: isLoading
      }), (0, _preact.h)(_InputGroup.default, {
        name: "password",
        title: "Password",
        type: "password",
        value: password,
        onChangeCallback: this.onInputChange,
        error: formErrors['password'],
        disabled: isLoading
      })), (0, _preact.h)("div", {
        className: "login-meta"
      }, (0, _preact.h)(_InputGroup.default, {
        inline: true,
        name: "remember",
        title: "Remember me",
        type: "checkbox",
        checked: remember,
        onChangeCheckbox: this.onInputChange
      }), (0, _preact.h)("a", {
        href: (0, _absoluteUrlRuntime.resolveUrl)(FORGOT_PASSWORD_URL),
        target: "__blank",
        className: "login-meta-forgot-password"
      }, "Forgot password?")), (0, _preact.h)(_buttonControl.default, {
        isLoading: isLoading,
        type: "submit",
        className: "login-button",
        variant: "brand",
        title: "Log in",
        fullWidth: true
      }), isStaffLoginEnabled && (0, _preact.h)("div", {
        className: "staff-login-buttons"
      }, (0, _preact.h)(_buttonControl.default, {
        onClick: function onClick() {
          return window.location.replace(STAFF_LOGIN_CONTROL_URL);
        },
        className: "login-button",
        variant: "purple",
        title: "Staff log in - control"
      }), (0, _preact.h)(_buttonControl.default, {
        onClick: function onClick() {
          return window.location.replace(STAFF_LOGIN_COMMUNITY_URL);
        },
        className: "login-button",
        variant: "purple",
        title: "Staff log in - community"
      }))));
    }
  }]);
  return LoginControl;
}(_preact.Component);

exports.default = LoginControl;

var Wrapper = function Wrapper(_ref3) {
  var onSubmit = _ref3.onSubmit,
      children = _ref3.children;
  return (0, _preact.h)("div", {
    className: "control-login"
  }, (0, _preact.h)("div", {
    className: "control-login-image-wrapper"
  }, (0, _preact.h)("img", {
    alt: "Gainsight Platform Logo",
    width: 265,
    src: (0, _absoluteUrlRuntime.resolveUrl)("".concat((0, _globals.default)('basePath')).concat(_constants.PLATFORM_GS_LOGO_PATH))
  })), (0, _preact.h)("form", {
    className: "control-login-wrapper",
    onSubmit: onSubmit
  }, children));
};